export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "5511999999999";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const SPECIALIST_MESSAGE =
  "Olá! Quero falar com um especialista da Pulse Saúde sobre o crescimento da minha clínica.";

export const scrollToSection = (selector) => {
  const el = document.querySelector(selector);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
